import {  selectSchema, textSchema, multiSelectSchema } from "../../../../shared/lib/schemas/common.schema";
import { z } from "zod";
import { residenceTypeOptions, structureTypeOptions, overallStatusOptions, goodwillStatusOptions, workScopeStatusOptions, kindOfRoofWorkOptions } from "../../constants/options";
import { makeOptional } from "@/shared/lib/helpers/schema.helpers";
import { homeOwnerAgeOptions, yesNoRejectedOptions } from "../../../../shared/constants/options";

// Assessment completed options
const assessmentCompletedOptions = [
    { value: 'No Assistance Required', label: 'No Assistance Required' },
    { value: 'Needed Not Started', label: 'Needed Not Started' },
    { value: 'Reassessment Needed', label: 'Reassessment Needed' },
    { value: 'Complete', label: 'Complete' }
];


export const getHomeOwnerQueryParamsSchema = z.object({
    page: makeOptional(z.number().min(1, "Page must be greater than 0")),
    limit: makeOptional(z.number().min(1, "Limit must be greater than 0")),
    search: makeOptional(textSchema("md")),
    overallStatus: makeOptional(multiSelectSchema(overallStatusOptions)),
    workscope: makeOptional(z.array(z.string())), // Work scope slugs (multiselect; options from API per region)
    workscopeStatus: makeOptional(multiSelectSchema(workScopeStatusOptions)), // Status of selected workscope(s)
    workscopeGoodwill: makeOptional(z.array(z.string())), // Goodwill workscope slugs (multiselect; filter by sections with goodwill toggled on)
    workscopeGoodwillStatus: makeOptional(multiSelectSchema(workScopeStatusOptions)), // Status of selected goodwill workscope(s)
    claimedBy: makeOptional(z.array(z.string())),
    /** Derived relief status (same labels as detail Overall Status row). */
    reliefStatus: makeOptional(multiSelectSchema(goodwillStatusOptions)),
    /** Derived rebuilding status (same labels as detail Overall Status row). */
    rebuildingStatus: makeOptional(multiSelectSchema(goodwillStatusOptions)),
    goodwillStatus: makeOptional(multiSelectSchema(goodwillStatusOptions)),
    roofing: makeOptional(multiSelectSchema(workScopeStatusOptions)),
    kindOfRoofWork: makeOptional(multiSelectSchema(kindOfRoofWorkOptions)),
    medicalNeeds: makeOptional(z.string()),
    homeownerAge: makeOptional(selectSchema(homeOwnerAgeOptions)),
    isSingleParent: makeOptional(z.string()),
    numChildrenUnder18: makeOptional(z.string()),
    isFirstResponder: makeOptional(z.string()),
    isVeteran: makeOptional(z.string()),
    hasFloodInsurance: makeOptional(z.string()),
    hasHomeInsurance: makeOptional(z.string()),
    femaStatus: makeOptional(selectSchema(yesNoRejectedOptions)),
    sbaStatus: makeOptional(selectSchema(yesNoRejectedOptions)),
    residenceType: makeOptional(multiSelectSchema(residenceTypeOptions)),
    structureType: makeOptional(multiSelectSchema(structureTypeOptions)),
    assessmentCompleted: makeOptional(multiSelectSchema(assessmentCompletedOptions)),
    homeownerName: makeOptional(z.string()),
    city: makeOptional(z.union([z.string(), z.array(z.string())])),
    county: makeOptional(z.union([z.string(), z.array(z.string())])),
    street: makeOptional(z.string()),
    updatedFrom: makeOptional(z.string()),
    updatedTo: makeOptional(z.string()),
    addedFrom: makeOptional(z.string()),
    addedTo: makeOptional(z.string()),
    activeStatus: makeOptional(z.union([z.enum(["active", "inactive", "all"]), z.literal("")])),
})


export const getHomeOwnerQueryParamsWithOutPaginationSchema = getHomeOwnerQueryParamsSchema.omit({
    page: true,
    limit: true,
})

export type GetHomeOwnerQueryParamsType = z.infer<typeof getHomeOwnerQueryParamsSchema>
export type GetHomeOwnerQueryParamsWithOutPaginationType = z.infer<typeof getHomeOwnerQueryParamsWithOutPaginationSchema>
